/*
    Name: optionsService.js
    Author: Derek Chan
    Description: service module for Global Options serice calls
*/
import axios from 'axios';
import DomainNameAPI from '../constants/DomainNameAPI';
import LoginService from '../utils/login-service';
import _ from 'lodash';
import Topics from '../constants/Topics';
import Constants from '../constants/Constants';
import ReactDOM from 'react-dom';

const apiError = Constants.API_SERVER_ERROR;
const variEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
const api_content_base_url = DomainNameAPI[variEnv].CONTENT_SERVICE_BASEURL;

//getContents function calls backend service to retrieve options, saves it to pubsub state
//argsObject = { Api, orgId, year }
const getContents = async (argsObject) => {
  if (_.isNil(argsObject.Api) || _.isNil(argsObject.orgId) || _.isNil(argsObject.year))
    throw new Error('getOptions call requires that Api, orgId, or year CANNOT be undefined or null');

  if (!LoginService.getTokens().isLoggedIn) {
    argsObject.Api.log('getNeedAnalysisContents() is called when user is not logged in');
    return;
  }

  var TARGET_CONTENT_SERVICE_URL =
    api_content_base_url +
    'orgId=' +
    argsObject.orgId +
    '&currentDate=' +
    new Date().toISOString() +
    '&year=' +
    argsObject.year;

  axios({
    method: 'GET',
    url: TARGET_CONTENT_SERVICE_URL,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then((response) => {
      argsObject.Api.Publish(Topics.OPTIONS_CONTENT_DATA, response.data);
    })
    .catch((error) => {
      argsObject.Api.log('calling getNeedAnalysisContents() failed ', error);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};

export default getContents;
